import React from "react";

import { IconProps } from "fe-shared/src/types/common";

const ArrowRightBig = ({
  width,
  height,
  style,
  className,
  fillClassName,
  fillColor,
}: IconProps) => (
  <svg
    style={style}
    width={width}
    height={height}
    aria-hidden="true"
    viewBox="0 0 24 24"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={fillColor!}
      fillRule="nonzero"
      className={fillClassName}
      d="M6.99767 21.0147C7.48767 21.5047 8.27767 21.5047 8.76767 21.0147L17.0777 12.7047C17.4677 12.3147 17.4677 11.6847 17.0777 11.2947L8.76767 2.98469C8.27767 2.49469 7.48767 2.49469 6.99767 2.98469C6.50767 3.47469 6.50767 4.26469 6.99767 4.75469L14.2377 12.0047L6.98767 19.2547C6.50767 19.7347 6.50767 20.5347 6.99767 21.0147Z"
    />
  </svg>
);

ArrowRightBig.defaultProps = {
  width: "24",
  height: "24",
  fillColor: "#63696F",
};

export default ArrowRightBig;
